import type { PaletteOptions } from '@mui/material/styles';

import { colorScales } from '../common/colors';

/**
 * Dark theme palette colors
 * Complete dark mode color palette
 */
export const darkPalette: PaletteOptions = {
  mode: 'dark',

  primary: {
    main: '#3795FA',
    light: '#53B1FD',
  },
  secondary: {
    main: '#00B3F0',
  },
  error: {
    main: '#F37370',
  },
  warning: {
    main: '#FFD666',
  },
  info: {
    main: '#53B1FD',
  },
  success: {
    main: '#4FD993',
  },

  background: {
    default: '#0A0A0A',
    paper: '#171717',
  },

  text: {
    primary: '#FFFFFF',
    secondary: '#B0B0B0',
    tertiary: '#808080',
    disabled: '#606060',
  },

  accent: {
    green: '#4FD993',
    blue: '#3795FA',
  },

  action: {
    active: '#FFFFFF',
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(255, 255, 255, 0.16)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },

  divider: 'rgba(255, 255, 255, 0.12)',

  ...colorScales,
};
